/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Listingbuttonsmovedown3Inputs */

const en_listingbuttonsmovedown3 = /** @type {(inputs: Listingbuttonsmovedown3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Move ${i?.label} down`)
};

const de_listingbuttonsmovedown3 = /** @type {(inputs: Listingbuttonsmovedown3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} nach unten`)
};

/**
* | output |
* | --- |
* | "Move {label} down" |
*
* @param {Listingbuttonsmovedown3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listingbuttonsmovedown3 = /** @type {((inputs: Listingbuttonsmovedown3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listingbuttonsmovedown3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listingbuttonsmovedown3(inputs)
	return de_listingbuttonsmovedown3(inputs)
});
export { listingbuttonsmovedown3 as "listingButtonsMoveDown" }